import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@core/integrations-http-legacy';

@Injectable({ providedIn: 'root' })
export class XingApiService extends IntegrationsApiService {
  public context: string = 'xing';
}
